import React, { useEffect, useState } from "react";
import ArticleCard from "../featuredInsights/articleCard";
import { BASE_SITE_URL } from "../../shared/constants";
import {
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
} from "react-share";
import { FaFacebookF, FaLinkedinIn, FaTwitter } from "react-icons/fa";

function TableContent({ objectData, content = "", articleContent }) {
  const [headings, setHeadings] = useState([]);
  const [activeHeading, setActiveHeading] = useState(true);

  useEffect(() => {
    if (!content) return;

    const extractedHeadings = [];
    const parser = new DOMParser();
    const doc = parser.parseFromString(content, "text/html");

    let currentSection = null;
    let index = 0;

    doc.querySelectorAll(".toc2, .toc3").forEach((element) => {
      const level = element.tagName === "H2" ? 2 : 3;
      const text = element.textContent.trim();
      const id = element.id || `heading-${index}`;

      if (level === 2) {
        // Create a new section for H2
        currentSection = { id, text, children: [] };
        extractedHeadings.push(currentSection);
      } else if (level === 3 && currentSection) {
        // Add H3 as a child of the last H2
        currentSection.children.push({ id, text });
      }

      index++;
    });

    setHeadings(extractedHeadings);
  }, [content]);

  const handleScroll = (e, targetId, offset = 100) => {
    e.preventDefault(); // Prevent default anchor behavior
    const targetElement = document.getElementById(targetId);

    if (targetElement) {
      window.scrollTo({
        top:
          targetElement.getBoundingClientRect().top + window.scrollY - offset, // Dynamic scrolling
        behavior: "smooth", // Smooth scroll
      });
    }
  };

  return (
    <div className="article-post-main-container">
      <div className="article-post-container">
        <div className="article-post-details">
          {headings.length > 0 && (
            <div className="article-post-header-block">
              <div className="article-post-control">
                <h2>Table of Contents</h2>
                <button onClick={() => setActiveHeading(!activeHeading)}>
                  {activeHeading ? "hide" : "show"}
                </button>
              </div>
              {activeHeading && (
                <div className="article-header-links">
                  <ul className="list-disc pl-4">
                    {headings?.map((heading, index) => (
                      <li key={heading.id} className="mb-2">
                        <div className="list-of-content-item">
                          <svg
                            width="24"
                            height="25"
                            viewBox="0 0 24 25"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <rect
                              y="0.26825"
                              width="24"
                              height="24"
                              rx="12"
                              fill="#E89F38"
                            />
                            <path
                              d="M18 5.86823L17.8364 5.75312L17.8363 5.75327L17.8359 5.75391L17.834 5.75655L17.8265 5.76719L17.7965 5.80952C17.77 5.84695 17.7303 5.9026 17.6783 5.97528C17.5743 6.12065 17.4205 6.33415 17.2221 6.60627C16.8253 7.15052 16.2497 7.92922 15.5354 8.86637C14.1064 10.7409 12.1229 13.2483 9.90367 15.7811C9.37776 16.381 8.90051 16.6 8.49311 16.6261C8.08233 16.6524 7.70105 16.4853 7.36422 16.2294C7.02742 15.9736 6.75049 15.6402 6.55592 15.3658C6.45924 15.2295 6.38428 15.1097 6.33373 15.0244C6.30847 14.9818 6.28938 14.948 6.27678 14.9251L6.26281 14.8994L6.25956 14.8932L6.25889 14.8919L6.25886 14.8919C6.25884 14.8918 6.25882 14.8918 6.25881 14.8918L6.2588 14.8918C6.2192 14.8152 6.13499 14.7726 6.04984 14.7861C5.96465 14.7996 5.89771 14.8662 5.88377 14.9513C5.69619 16.0971 5.8337 16.9783 6.19672 17.6173C6.56149 18.2594 7.14102 18.634 7.78759 18.7867C9.06416 19.0883 10.625 18.5323 11.4303 17.46L11.4304 17.46C12.5341 15.9903 14.2229 13.1104 15.6303 10.6091C16.3354 9.3562 16.9719 8.19455 17.4321 7.34617C17.6622 6.92195 17.8483 6.576 17.9769 6.33607C18.0412 6.2161 18.0911 6.12263 18.125 6.05912L18.1635 5.98677L18.1733 5.96827L18.1758 5.96357L18.1764 5.96238L18.1766 5.96208C18.1766 5.96201 18.1767 5.96197 18 5.86823ZM18 5.86823L17.8365 5.75308C17.8973 5.66675 18.0147 5.64254 18.1047 5.69779C18.1946 5.75304 18.2262 5.86871 18.1767 5.96197L18 5.86823Z"
                              fill="white"
                              stroke="white"
                              strokeWidth="0.4"
                              strokeLinejoin="round"
                            />
                          </svg>
                          <div>
                            <span className="">{++index}. </span>
                            <a
                              href={`#${heading.id}`}
                              onClick={(e) => handleScroll(e, heading.id)}
                              className="text-blue-500 hover:underline font-semibold"
                            >
                              {heading.text}
                            </a>
                          </div>
                        </div>

                        {heading?.children?.length > 0 && (
                          <ul className="haja pl-6">
                            {heading?.children?.map((child, valkey) => (
                              <li key={child?.id} className="mt-1">
                                <div>
                                  <span className="">
                                    {index}.{++valkey}.{" "}
                                  </span>{" "}
                                  <a
                                    href={`#${child?.id}`}
                                    onClick={(e) => handleScroll(e, heading.id)}
                                    className="text-blue-500 hover:underline"
                                  >
                                    {child?.text}
                                  </a>
                                </div>
                              </li>
                            ))}
                          </ul>
                        )}
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
          )}

          <div className="article-post-body-block">
            <div
              className="article_content"
              dangerouslySetInnerHTML={{
                __html: content,
              }}
            />
          </div>
          <div className="article-share-container">
            <h2>Share</h2>
            <div className="article-share-card">
              <div className="share-card-icon-wrapper">
                <LinkedinShareButton
                  url={`${BASE_SITE_URL}/article/${
                    articleContent && articleContent?.slug
                  }`}
                >
                  <FaLinkedinIn className="icon" color="#fff" size="20px" />
                </LinkedinShareButton>
              </div>
              <div className="share-card-icon-wrapper">
                <FacebookShareButton
                  url={`${BASE_SITE_URL}/article/${
                    articleContent && articleContent?.slug
                  }`}
                >
                  <FaFacebookF className="icon" color="#fff" size="20px" />
                </FacebookShareButton>
              </div>
              <div className="share-card-icon-wrapper">
                <TwitterShareButton
                  url={`${BASE_SITE_URL}/article/${
                    articleContent && articleContent?.slug
                  }`}
                >
                  <FaTwitter className="icon" color="#fff" size="20px" />
                </TwitterShareButton>
              </div>
              {/* <div className="share-card-icon-wrapper">
                <a
                  target="_blank"
                  href={`https://instagram.com/?url=${encodeURIComponent(
                    `${BASE_SITE_URL}/article/${
                      articleContent && articleContent?.slug
                    }`
                  )}`}
                  rel="noreferrer"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="30"
                    height="30"
                    viewBox="0 0 24 24"
                  >
                    <path
                      fill="#fff"
                      d="M7.8 2h8.4C19.4 2 22 4.6 22 7.8v8.4a5.8 5.8 0 0 1-5.8 5.8H7.8C4.6 22 2 19.4 2 16.2V7.8A5.8 5.8 0 0 1 7.8 2m-.2 2A3.6 3.6 0 0 0 4 7.6v8.8C4 18.39 5.61 20 7.6 20h8.8a3.6 3.6 0 0 0 3.6-3.6V7.6C20 5.61 18.39 4 16.4 4zm9.65 1.5a1.25 1.25 0 0 1 1.25 1.25A1.25 1.25 0 0 1 17.25 8A1.25 1.25 0 0 1 16 6.75a1.25 1.25 0 0 1 1.25-1.25M12 7a5 5 0 0 1 5 5a5 5 0 0 1-5 5a5 5 0 0 1-5-5a5 5 0 0 1 5-5m0 2a3 3 0 0 0-3 3a3 3 0 0 0 3 3a3 3 0 0 0 3-3a3 3 0 0 0-3-3"
                    />
                  </svg>
                </a>
              </div> */}
            </div>
          </div>
        </div>
        <div className="article-post-list">
          {objectData && objectData.length > 0 && (
            <ArticleCard
              miniviewData={objectData}
              title="Related Articles"
              className="article-card-body_column"
              isAllArticles={false}
              type={"related"}
            />
          )}
        </div>
      </div>
    </div>
  );
}

export default TableContent;
